import { useEffect, useState } from 'react';
import { api } from '../../api/client';

export default function VendorProfilePicker({ shopId, value, onChange, disabled }) {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    if (!shopId) return;
    let cancelled = false;
    setLoading(true);
    api.listVendorProfiles(shopId)
      .then(d => { if (!cancelled) { setProfiles(d.vendors || d.profiles || []); setLoading(false); } })
      .catch(() => { if (!cancelled) { setProfiles([]); setLoading(false); } });
    return () => { cancelled = true; };
  }, [shopId]);

  const filtered = profiles.filter(p =>
    !filter || (p.canonical_name || '').toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div>
      <input
        type="text"
        placeholder={loading ? 'Loading vendors…' : 'Search vendors…'}
        value={filter}
        onChange={e => setFilter(e.target.value)}
        disabled={disabled}
        className="w-full px-3 py-2 rounded-md border border-[var(--color-warm-200)] focus:outline-none focus:border-[var(--color-warm-500)] text-[14px]"
      />
      <div className="mt-2 max-h-48 overflow-y-auto rounded-md border border-[var(--color-warm-200)] bg-white">
        {filtered.length === 0 && (
          <div className="px-3 py-4 text-[12px] text-[var(--color-warm-500)] text-center italic">
            {loading ? '…' : 'No matching vendors'}
          </div>
        )}
        {filtered.map(p => (
          <button
            key={p.id}
            onClick={() => onChange(p.id)}
            disabled={disabled}
            className={`w-full px-3 py-2 text-left text-[13px] flex items-center justify-between hover:bg-[var(--color-cream-100)] border-b border-[var(--color-warm-100)] last:border-b-0 ${
              value === p.id ? 'bg-[var(--color-recovery-50)]' : ''
            }`}
          >
            <span className="font-medium text-[var(--color-warm-900)] truncate">{p.canonical_name}</span>
            {p.vendor_category && (
              <span className="text-[10px] uppercase tracking-wider text-[var(--color-warm-500)] ml-2">
                {p.vendor_category.replace('_', ' ')}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
